import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setBackButtonUrl } from "../uiSlice";
import { setupAppPageBodyBackground } from "../game/gameStageBackground";
import "../fonts/breuer-headline.css";
import "./intro.css";

import introDesk from "../img/intro_desk.jpg";
import introMob from "../img/intro_mob.jpg";
import letterBg from "../img/letter.png";
import startBtnImg from "../img/start.png";
import tipBg from "../img/black_button.png";

function Intro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [nextLoading, setNextLoading] = useState(false);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch]);

  useEffect(() => {
    return setupAppPageBodyBackground(document.body, {
      deskForeground: introDesk,
      mobForeground: introMob,
    });
  }, []);

  const handleBegin = useCallback(
    (e) => {
      e.preventDefault();
      if (!user || nextLoading) return;
      setNextLoading(true);
      navigate("/rules", { replace: true });
    },
    [user, nextLoading, navigate]
  );

  return (
    <div className="intro-page">
      <div className="intro-layout">
        <div
          className="intro-letter"
          style={{ backgroundImage: `url(${letterBg})` }}
        >
          <div className="intro-letter__inner">
            <h1 className="intro-letter__title">WELCOME, CONSERVATOR!</h1>
            <div className="intro-letter__rule" aria-hidden="true" />
            <div className="intro-letter__body">
              <p>
                Tomorrow is Independence Day, and the Museum of India opens its
                biggest exhibition of the year.
              </p>
              <p>
                Unfortunately, two of our most important galleries were left in
                complete chaos overnight.
              </p>
              <p className="intro-letter__mission">
                Your mission is to restore every exhibit and reopen the museum
                before the visitors arrive.
              </p>
            </div>
            <div className="intro-letter__rule" aria-hidden="true" />
            <button
              type="button"
              className="intro-start-btn"
              disabled={nextLoading || !user}
              onClick={handleBegin}
              style={{ backgroundImage: `url(${startBtnImg})` }}
            >
              {nextLoading ? "LOADING…" : "BEGIN RESTORATION"}
            </button>
          </div>
        </div>

        <div
          className="intro-tip"
          style={{ backgroundImage: `url(${tipBg})` }}
          role="note"
        >
          <span className="intro-tip__bulb" aria-hidden="true">
            💡
          </span>
          <p className="intro-tip__text">
            <span className="intro-tip__label">TIP:</span> Explore every corner.
            Every clue brings history back to life.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Intro;
